import { render, staticRenderFns } from "./GraduateTracking.vue?vue&type=template&id=1c22546f"
import script from "./GraduateTracking.vue?vue&type=script&lang=js"
export * from "./GraduateTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports